import React, { useEffect } from 'react'
import { setSchoolData, selectors } from './slice';
import { useDispatch, useSelector } from 'react-redux';
import { getMap } from '../map/mapInstance';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import {Fill, Stroke, Style, Circle} from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import Select from 'ol/interaction/Select';
import {pointerMove} from 'ol/events/condition';
import Overlay from 'ol/Overlay';
import { store } from '../store';
import Popup from '../../components/popup';
import { renderToString } from 'react-dom/server'

const COLORS = {
    green: 'green',
    orange: 'orange',
    red: 'red',
    grey: 'grey'
}

const YEAR_MAP = {
    '2024': '2023./24.',
    '2023': '2022./23.',
    '2022': '2021./22.',
    '2021': '2020./21.',
    '2020': '2019./20.',
    '2019': '2018./19.',
    '2018': '2017./18.',
};

const SUBJECT_MAP = {
    'FIZ': 'Fizika',
    'MAT': 'Matemātika',
    'MAT_opt': 'Matemātika (opt.)',
    'MAT_visp': 'Matemātika (visp.)',
    'KIM': 'Ķīmija'
};

const NONE = null;

let tooltip;
let selectInteraction;

const createTooltip = () => {
	const tooltipEl = document.createElement('div');
	tooltipEl.className = 'tooltip';

	const overlay = new Overlay({
		element: tooltipEl,
		offset: [30, 0],
		positioning: 'bottom-left',
	});

	return overlay;
};

const styleFunction = (feature, resolution, filterYear, filterSubject, participantCountGroup) => {

    const props = feature.getProperties();

    let kartoja = props[filterSubject + '_' + filterYear + '_kopa'];
    let virs60 = props[filterSubject + '_' + filterYear + '_60'];
        
    if (filterSubject.includes('opt')) {
        kartoja = props[filterSubject.replace('_opt', '') + '_' + filterYear + '_opt_kopa'];
        virs60 = props[filterSubject.replace('_opt', '') + '_' + filterYear + '_opt_60'];
    }

    if (filterSubject.includes('visp')) {
        kartoja = props[filterSubject.replace('_visp', '') + '_' + filterYear + '_visp_kopa'];
        virs60 = props[filterSubject.replace('_visp', '') + '_' + filterYear + '_visp_60'];
    }

    if(kartoja === undefined) {
        return null;
    }

    if (props['start'] >= filterYear || props['end'] < filterYear) {
        return null;
    }

    let color = COLORS.red;

    if(kartoja === (NONE || "")) {
        kartoja = 0;
    }

    if(virs60 === (NONE || "")) {
        virs60 = 0;
    }

    if(parseInt(kartoja) === 0) {
        if (filterSubject.includes('opt')) {
            return null;
        }

        color = COLORS.red;
    } else if (parseInt(kartoja) > 0 && parseInt(virs60) === 0) {
        color = COLORS.orange;
    } else if (parseInt(kartoja) > 0 && parseInt(virs60) > 0) {
        color = COLORS.green;
    }

    if(
        participantCountGroup.min !== null && participantCountGroup.max !== null &&
        (
            participantCountGroup.min > parseInt(kartoja) || 
            participantCountGroup.max < parseInt(kartoja)
        ) 
    ) {
        return null;
    }

    let radius = 6;

    if(parseInt(kartoja) === 1) {
        radius = 8;
    } else if (parseInt(kartoja) >= 2 && parseInt(kartoja) <= 9) {
        radius = 12;
    } else if (parseInt(kartoja) >= 10 && parseInt(kartoja) <= 20) {
        radius = 16;
    } else if (parseInt(kartoja) > 20) {
        radius = 20;
    }

    /*if(kartoja !== NONE) {

        radius = Math.sqrt(parseInt(kartoja) / Math.PI)*15 + radius;
    }*/

    return  [new Style({
        zIndex: -radius,
		image: new Circle({
                radius: radius,
                stroke: new Stroke({
                    color: '#ffffff',
                    width: 2,
                }),
                fill: new Fill({
                    color: color,
                }),
            }),
        }),
	];
}

const vectorLayer = new VectorLayer({
//    style: (feature, resolution)=> { return styleFunction() },
});

var actualFilterYear = 0;
var actualFilterSubject = 'FIZ';
var actualParticipantCountGroup = 5;

const map = () => {

    const data = useSelector(selectors.schoolData);
    const filterYear = useSelector(selectors.filterYear);
    const filterSubject = useSelector(selectors.filterSubject);
    const participantCountGroup = useSelector(selectors.participantCountGroup);

    const dispatch = useDispatch();

    useEffect(()=>{
        fetch('https://daugava.kartes.lv/api/object_group/9d6aad2b-a903-4087-94c4-faada82ecd52/list'
        )
            .then(response => response.json())
            .then(data => {
                dispatch(setSchoolData(data));
        });

        // fetch('./scripts/eks_dati.geojson')
        //         .then(response => response.json())
        //         .then(data => {
        //             dispatch(setSchoolData(data));
        //       });
    },[]);

    useEffect(() => {
        const map = getMap();
        map.addLayer(vectorLayer); 
        
        tooltip = createTooltip();
        map.addOverlay(tooltip);

        selectInteraction = new Select({
            condition: pointerMove,
            style: (feature, resolution) => {
                
                store.getState();

                return styleFunction(feature, resolution, actualFilterYear, actualFilterSubject, actualParticipantCountGroup);
            },
        });

        map.addInteraction(selectInteraction);

        selectInteraction.on('select', (e) => {

            const featureSelected = selectInteraction.getFeatures().getArray()[0];

            if(featureSelected) {
                const rootProps = featureSelected.getProperties();
                const props = rootProps;

                let kartoja = props[actualFilterSubject + '_' + actualFilterYear + '_kopa'];
                let virs60 = props[actualFilterSubject + '_' + actualFilterYear + '_60'];

                if (actualFilterSubject.includes('opt')) {
                    kartoja = props[actualFilterSubject.replace('_opt', '') + '_' + actualFilterYear + '_opt_kopa'];
                    virs60 = props[actualFilterSubject.replace('_opt', '') + '_' + actualFilterYear + '_opt_60'];
                }

                if (actualFilterSubject.includes('visp')) {
                    kartoja = props[actualFilterSubject.replace('_visp', '') + '_' + actualFilterYear + '_visp_kopa'];
                    virs60 = props[actualFilterSubject.replace('_visp', '') + '_' + actualFilterYear + '_visp_60'];
                }

                tooltip.getElement().innerHTML = renderToString(<Popup data={[
                    ['Skolas nosaukums', rootProps.name],
                    ['Mācību gads', YEAR_MAP[actualFilterYear]],
                    ['Mācību priekšmets', SUBJECT_MAP[actualFilterSubject]],
                    ['Kārtotāju skaits', kartoja !== (NONE || "") ? kartoja : '0'],
                    ['Rezultāts vismaz 60%', virs60 !== (NONE || "" ) ? virs60 : '0'],
                ]} />);
                const coords = featureSelected.getGeometry().getCoordinates();
                tooltip.setPosition(coords);
                
            } else {
                tooltip.setPosition(undefined);
            }
        });

    }, []);

    useEffect(() => {

        vectorLayer.setStyle((feature, resolution) => 
            styleFunction(feature, resolution, filterYear, filterSubject, participantCountGroup)
        );

        actualFilterYear = filterYear;
        actualFilterSubject = filterSubject;
        actualParticipantCountGroup = participantCountGroup;

        if(tooltip) {
            tooltip.setPosition(undefined);
            selectInteraction.getFeatures().clear();
        }

    }, [filterYear, filterSubject, participantCountGroup]);

    useEffect(() => {

        if(!data) {
            return;
        }
        const map = getMap();
        const currentProjection = map.getView().getProjection().getCode();
        const vectorSource = new VectorSource({
            features: new GeoJSON().readFeatures(data, {
                dataProjection: 'EPSG:4326',
				featureProjection: currentProjection,
            }),
        });
        vectorLayer.setSource(vectorSource)

    }, [data]);

    return null;
}

export default map;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/features/schools/map.js